import { isFunction, isUndefined } from 'lodash-es';

import { formatDate, FormatDateOptions } from '@dynatrace-sdk/units';

import { formatDateTicks } from './format-date-ticks.js';
import { TimeFormatter } from '../types/formatter.js';

export const getTimeFormatter = (
  axisFormatter: TimeFormatter | FormatDateOptions | undefined,
) => {
  if (isUndefined(axisFormatter)) {
    return (value: number | Date) => formatDateTicks(new Date(value));
  } else if (isFunction(axisFormatter)) {
    return (value: number | Date) => axisFormatter(new Date(value));
  } else {
    return (value: number | Date) => formatDate(value, axisFormatter);
  }
};
